document.addEventListener("DOMContentLoaded", function() {

    const header24 = document.querySelector("._header-24");
    const showMenuMobile = document.querySelector("#_show-menu-mobile");
    const showSearch = document.querySelector("#_show-search");
    const ctaSelector = ".__glide-banner-cta"
    const glideCta = document.querySelector(ctaSelector);

    if(header24) {
        showMenuMobile.addEventListener("click", function() {
            window.dispatchEvent(new CustomEvent("showMenuMobile"));
        })
    }

    if(showSearch) {
        showSearch.addEventListener("click", function(eve) {
            window.dispatchEvent(new CustomEvent("showSearchForm"));
        })
    }

    if(glideCta) {
        new Glide(ctaSelector, {
            type: 'carousel',
            autoplay: 2500
        }).mount();
    }

});